module.exports = __webpack_public_path__ + "img/czsc_19.c031651a.png";